import * as types from './mutation-types';
import stateOrigin from './state';

export default {
	//state의 값을 변경해주기 위한 유틸성 Mutation
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	},

	//로그인 api를 통해 가져온 정보를 store에 저장
	[types.SET_LOGIN_INFO]: (state, payload) => {
		//사용자 정보 및 plant 코드 저장
		state.user = { ...payload.data.user, userId: window.btoa(payload.data.user.userId), plantCd: payload.data.plantCd };

		//언어, 색상 테마, 폰트 테마 저장
		state.langCd = payload.data.user.langCd;
		state.topSkin = payload.data.user.topSkin;
		state.font = payload.data.user.font;

		//메뉴리스트와 로그인 후 처음 접근할 url 저장
		state.menuList = payload.data.menus;
		// state.homeUrl = payload.data.homeUrl;

		//인위적으로 만든 Home 화면에 보여줄 Content화면 정보
		state.homeContentUrl = payload.data.homeContentUrl;
		state.homeScrId = payload.data.homeScrId;

		state.sessionState = true; //세션 감시 시작
		state.sessionTimeout = payload.data.sessionTimeout; //세션 Timeout 시간
		state.screenTimeout = payload.data.screenTimeout; //스크린 Timeout 시간
		state.sessionAlarmTime = payload.data.sessionAlarmTime; //세션 강조 기준 시간

		//세션 초기값 설정 10분
		state.sessionCounter = payload.data.sessionTimeout; //600: 10분(86400: 24시간)
		state.screenCounter = payload.data.screenTimeout; //사용자 움직임 감시 남은 시간, 기본 값: 1800(30분)

		//중복로그인 처리에 사용할 사용자 sessionId 저장
		state.sessionId = window.btoa(payload.data.sessionId);
	},

	//Menu List를 Map으로 변환하여 저장
	[types.SET_MENU_MAP]: state => {
		let menuMap = new Map();

		// homeMenu는 menuList의 메뉴들을 접근할 수 있는 home 메뉴 화면을 만들기 위함
		// 일반적인 프로젝트는 메뉴구조가 1개이지만 여러개의 0Depth의 메뉴를 사용하는 경우 아래처럼 Menu 정보를 이용해 신규 Menu 생성
		let homeMenu = {};
		if (1 < state.menuList.length) {
			homeMenu = {
				scrName: 'Home',
				scrUrl: '/home',
				scrType: 'H',
				msgKey: 'S90000001',
				sitemapYN: 'N',
				useTabMenuYN: 'N',
				useTopMenuYN: 'Y',
				useSideMenuYN: 'N',
				menuItemList: [],
				menuItemMap: new Map()
			};
			state.homeUrl = '/home';
		} else {
			state.homeUrl = state.menuList[0].scrUrl;
		}

		//사용자의 메뉴 정보를 이용해 Map으로 가공
		for (let menu of state.menuList) {
			let menuInfo = menu;
			let menuItemMap = new Map();
			//console.log("snjung::vue1",menuItemMap, state.userMessage, menu.menuItemList, 0);
			let menuItemList = calculateMenu(menuItemMap, state.userMessage, menu.menuItemList, 0);
			//console.log("snjung::vue2",menuItemList);
			if (!menu.contentScrId && menu.sitemapYN === 'Y') menu.contentScrId = 'sitemap';

			menuInfo = {
				scrName: menu.scrName,
				scrUrl: menu.scrUrl,
				msgKey: menu.msgKey,
				sitemapYN: menu.sitemapYN,
				useTabMenuYN: menu.useTabMenuYN,
				useTopMenuYN: menu.useTopMenuYN,
				useSideMenuYN: menu.useSideMenuYN,
				scrType: menu.scrType,
				contentScrId: menu.contentScrId,
				menuItemList,
				menuItemMap
			};
			menuMap.set(menu.scrType, menuInfo);

			// homeMenu는 menuList의 메뉴들을 접근할 수 있수 있도록 1댑스 메뉴로 넣어서 menuList 생성(단 하위에 메뉴가 1개라도 있을 경우만 생성)
			if (1 < state.menuList.length && 0 < menuItemMap.size) {
				homeMenu.menuItemList.push({ name: menu.scrName, url: menu.scrUrl, msgKey: menu.msgKey, items: [] });
			}
		}

		// menuMap에 homeMenu정보를 추가
		if (1 < state.menuList.length) {
			menuMap.set(homeMenu.scrType, homeMenu);
		}

		//계산한 menuMap을 Vuex Store에 저장
		state.menuMap = menuMap;
	},

	//api를 이용해 가져온 다국어 리스트를 Map으로 변환하여 store 저장
	[types.SET_USER_MESSAGE]: (state, payload) => {
		const messageMap = new Map();
		if (payload) {
			payload.data.forEach(element => {
				messageMap.set(element.key, element.value);
			});
			state.userMessageList = payload.data;
		} else {
			state.userMessageList.forEach(element => {
				messageMap.set(element.key, element.value);
			});
		}
		state.userMessage = messageMap;
	},

	//로그아웃 때 사용하는 store 값 초기화
	[types.SET_INIT_STORE]: state => {
		// state를 초기화 시키지만, 다국어는 로그인 했던 사용자의 다국어 map으로 셋팅하여 로그인 페이지를 보여줌
		Object.assign(state, {
			...stateOrigin,
			userMessage: state.userMessage,
			langCd: state.langCd,
			topSkin: state.topSkin,
			font: state.font
		});
	},

	//세션 시간 1초씩 감소
	[types.SET_SESSION_TIMER]: state => {
		state.sessionCounter = state.sessionCounter - 1;
	},

	//화면 세션 시간 1초씩 감소
	[types.SET_SCREEN_TIMER]: state => {
		state.screenCounter = state.screenCounter - 1;
	},

	//onsite에서 화면 정보 조회
	[types.SET_SCREEN]: (state, payload) => {
		let screen = new Map();
		// if (state.screenArray.size > 0) {
		if (state.screenArray.size > 0 || !state.screenArray) {
			screen = state.screenArray;
		}
		let screenContent = { ...payload.data };

		let screenBtn = new Map();
		payload.data.btnList.forEach(btn => {
			screenBtn.set(btn.functionType, btn);
		});
		screenContent.screenBtn = screenBtn;

		screenContent.pageArray = payload.data.pageSize.map(page => Number(page.commCd));
		screenContent.defaultPageSize = Number(payload.data.defaultPageSize);

		screen.set(payload.scrId, screenContent);

		state.screenArray = screen;
		state.screenObj = payload;

		//console.log('SET_SCREEN');
	}

	//TODO 안쓰는거 맞는지 확인하고 테스트
	// [types.SEARCH_PARAM]: (state, payload) => {
	// 	state.searchParams[payload.key] = payload.value;
	// }
};

//메뉴 정보들에서 필요한 것들만 뽑고 가공하여 menu 정보 추출
function calculateMenu(menuMap, userMessage, menus, depth) {
	if (menus && menus.length > 0) {
		return menus.map(menu => {
			let temp = {};
			temp.msgKey = menu.msgKey;
			temp.name = userMessage.get(menu.msgKey);
			temp.authItemList = menu.authItemList;
			temp.scrId = menu.scrId;
			temp.direct = menu.direct;

			//msa 일 때
			if (process.env.VUE_APP_ONSITE_PROJECT === 'false') {
				temp.url = menu.scrUrl;
			}
			//onsite 일 때
			if (process.env.VUE_APP_ONSITE_PROJECT === 'true' && menu.scrUrl != null) {
				temp.component = () => import(`@/views/${menu.scrUrl}.vue`);
			}

			if (temp.scrId) {
				menuMap.set(menu.scrId, temp);
			}

			if (process.env.VUE_APP_MENU_ICON === 'true' && depth === 0) {
				//scr_LV 1인 메뉴들의 아이콘을 사이트맵이나 사이드 메뉴에서 보여주기 위해 아이콘 설정, DB에 등록된 scrName의 소문자로 icon 등록 필요
				temp.icon = `icon-sf-menu-${menu.scrName.toLowerCase()}`;
			}
			if (menu.menuItemList) {
				temp.items = calculateMenu(menuMap, userMessage, menu.menuItemList, depth + 1);
			}
			return temp;
		});
	} else {
		return [];
	}
}
